import { formatDateDefault } from 'services/DateFormatters';
import { fetchDataRequest } from 'services/ApiService';
import { ORGID_PATH_PARAM, ISSUEID_PATH_PARAM } from 'constants/api';
import { isValueEntered } from 'services/Validation';

/**
 * get basic issue data - no api call
 * @param {*} issue 
 */
export const getDisplayData = (issue) => {
    return {
        id: issue?.id ? issue?.id : 0,
        name: issue?.name ? issue?.name : 'No name specified',
        description: issue?.description ? issue?.description : 'No description specified',
    };
};

/**
 * Get more detailed information - makes an api call
 * @param {*} issueId 
 * @param {*} orgid 
 */
export const getIssueDisplayData = async (issueId, orgid) => {
    const fetchedData = await fetchDataRequest('issueDisplayData', [ORGID_PATH_PARAM, ISSUEID_PATH_PARAM], [orgid, issueId]) || [];
    return {
        id: fetchedData?.id ? fetchedData?.id : 0,
        name: fetchedData?.name ? fetchedData?.name : 'No name specified',
        description: fetchedData?.description ? fetchedData?.description : 'No description specified',
        type: fetchedData?.type ? fetchedData?.type : 'No type specified',
        assigneeName: isValueEntered(fetchedData?.assigneeName) ? fetchedData?.assigneeName : 'No assignee specified',
        featureName: isValueEntered(fetchedData?.featureName) ? fetchedData?.featureName : 'No feature specified',
        startDate: fetchedData?.startDate ? formatDateDefault(fetchedData?.startDate) : 'No start date specified',
        endDate: fetchedData?.endDate ? formatDateDefault(fetchedData?.endDate) : 'No end date specified',
        releaseEnv: fetchedData?.releaseEnv ? fetchedData?.releaseEnv : 'No release environment specified', 
        releaseDate: fetchedData?.releaseDate ? formatDateDefault(fetchedData?.releaseDate) : 'No release date specified', 
        releaseCutoffDate: fetchedData?.releaseCutoffDate ? formatDateDefault(fetchedData?.releaseCutoffDate) : 'No release cutoff specified', 
        releaseVersion: fetchedData?.releaseVersion ? fetchedData?.releaseVersion : 'No release version specified', 
    };
};

// temp solution to mock drill down data after component generation - data may not exist
// makes it easy to clean up mock data and use real data when available (just search for this functions usage)
export const getMockDrillDownData = () => {
    return [{ id: '2578cb65923bb7ba0845014820190617', name: 'fake feature number 1', description: 'description number 1' }, { id: '9876cb65923bb7ba0845014820190617', name: 'fake feature number 2', description: 'description number 2' }];
};





// WEBPACK FOOTER //
// ./services/issueService.js